import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useDomainUsersByCompanyReducer = () =>
	useSelector((state: ApplicationState) => state.domainUsersByCompany);
